import PageLayout from "@/pages/home/components/PageLayout";
import ScheduleSection from "@/pages/home/components/ScheduleSection";

export default function SchedulePage() {
  return (
    <PageLayout>
      <ScheduleSection />
    </PageLayout>
  );
}
